import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white', textAlign: 'center', padding: '20px'
    }}>
      <div style={{ fontSize: '80px', marginBottom: '10px' }}>📄</div>
      <h1 style={{ fontSize: '72px', margin: '0', fontWeight: 'bold' }}>404</h1>
      <h2 style={{ fontSize: '24px', margin: '10px 0' }}>Page Not Found</h2>
      <p style={{ fontSize: '16px', opacity: '0.8', maxWidth: '400px', marginBottom: '30px' }}>
        Looks like this page got lost in compilation! Let us take you back.
      </p>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button onClick={() => navigate('/')} style={{
          padding: '12px 24px', background: 'white', color: '#667eea',
          border: 'none', borderRadius: '8px', cursor: 'pointer',
          fontWeight: 'bold', fontSize: '15px'
        }}>Go Home</button>
        <button onClick={() => navigate('/editor')} style={{
          padding: '12px 24px', background: 'transparent', color: 'white',
          border: '2px solid white', borderRadius: '8px', cursor: 'pointer',
          fontWeight: 'bold', fontSize: '15px'
        }}>Open Editor</button>
      </div>
    </div>
  );
}

export default NotFound;
